<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px" @keydown="checkEsc">
      <v-card>
        <v-card-title>
          <h5>{{ questionnaireName }}</h5>
          <h6 class="text-center">
            №{{ docNum }} {{ $t('docZN.dated') }} {{ docDate }} {{ signature }}
          </h6>
        </v-card-title>
        <v-card-text>
          <div
            v-for="(itemPart, indexPart) in questionnaireData"
            :key="indexPart"
          >
            <div>
              <div
                @click="
                  hidenTabs.indexOf(itemPart.rowId) !== -1
                    ? (hidenTabs = hidenTabs.replace(itemPart.rowId + ';', ''))
                    : (hidenTabs = hidenTabs + itemPart.rowId + ';')
                "
                class="d-flex flex-row  accordion-row"
                v-bind:class="{ 'active-row': currentPart === itemPart.rowId }"
              >
                <div class="d-flex flex-grow-0">
                  <v-avatar
                    v-if="currentPart !== itemPart.rowId"
                    size="25px"
                    tile
                  >
                    <i aria-hidden="true" class="v-icon material-icons">add</i>
                  </v-avatar>
                  <v-avatar
                    v-if="currentPart === itemPart.rowId"
                    size="25px"
                    tile
                  >
                    <i aria-hidden="true" class="v-icon material-icons"
                      >remove</i
                    >
                  </v-avatar>
                </div>
                <div class="date-txt-holder">
                  <h5>{{ itemPart.rowName }}</h5>
                </div>
              </div>
              <div v-if="hidenTabs.indexOf(itemPart.rowId) === -1">
                <v-data-table
                  :headers="headers"
                  :items="itemPart.rowList"
                  hide-headers
                  hide-actions
                  class="elevation-1"
                  ref="dataTable"
                >
                  <template slot="items" slot-scope="props">
                    <tr class="tab-row tr-" :key="props.item.rowName">
                      <td class="text-xs-left">{{ props.item.rowName }}</td>
                      <td class="text-xs-right action-holder">
                        <div v-if="props.item.valueType === '0'">
                          <div v-if="props.item.rowUseLR" class="d-flex">
                            <div class="d-flex align-items-center">
                              <span>L:&nbsp;</span>
                              <v-btn
                                v-if="props.item.valueL === ''"
                                icon
                                middle
                                @click="props.item.valueL = '1'"
                                class="flex-grow-0"
                              >
                                <i class="v-icon material-icons">help_outline</i>
                              </v-btn>
                              <v-btn
                                v-if="props.item.valueL === '1'"
                                icon
                                middle
                                @click="props.item.valueL = '2'"
                                class="flex-grow-0"
                              >
                                <i class="v-icon material-icons"
                                >check_circle_outline</i
                                >
                              </v-btn>
                              <v-btn
                                v-if="props.item.valueL === '2'"
                                icon
                                middle
                                @click="props.item.valueL = ''"
                                class="flex-grow-0"
                              >
                                <i class="v-icon material-icons">highlight_off</i>
                              </v-btn>
                            </div>
                            <div class="d-flex align-items-center">
                              <span>R:&nbsp;</span>
                              <v-btn
                                v-if="props.item.valueR === ''"
                                icon
                                middle
                                @click="props.item.valueR = '1'"
                                class="flex-grow-0"
                              >
                                <i class="v-icon material-icons">help_outline</i>
                              </v-btn>
                              <v-btn
                                v-if="props.item.valueR === '1'"
                                icon
                                middle
                                @click="props.item.valueR = '2'"
                                class="flex-grow-0"
                              >
                                <i class="v-icon material-icons"
                                >check_circle_outline</i
                                >
                              </v-btn>
                              <v-btn
                                v-if="props.item.valueR === '2'"
                                icon
                                middle
                                @click="props.item.valueR = ''"
                                class="flex-grow-0"
                              >
                                <i class="v-icon material-icons">highlight_off</i>
                              </v-btn>
                            </div>
                          </div>
                          <div v-else>
                            <v-btn
                              v-if="props.item.value === ''"
                              icon
                              middle
                              @click="props.item.value = '1'"
                            >
                              <i class="v-icon material-icons">help_outline</i>
                            </v-btn>
                            <v-btn
                              v-if="props.item.value === '1'"
                              icon
                              middle
                              @click="props.item.value = '2'"
                            >
                              <i class="v-icon material-icons"
                              >check_circle_outline</i
                              >
                            </v-btn>
                            <v-btn
                              v-if="props.item.value === '2'"
                              icon
                              middle
                              @click="props.item.value = ''"
                            >
                              <i class="v-icon material-icons">highlight_off</i>
                            </v-btn>
                          </div>
                        </div>
                        <div v-if="props.item.valueType === '1'">
                          <v-text-field
                            :label="globalTexts.comment"
                            v-model="props.item.value"
                          ></v-text-field>
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="flex-column flex-sm-row justify-space-between">
          <div class="d-flex justify-space-between flex-grow-1">
            <v-btn  class="my-3" @click="saveForm()">{{ $t('global.save') }}</v-btn>
            <v-btn  class="my-3" @click="dialog = false">{{ $t('global.cancel') }}</v-btn>
          </div>
          <v-btn  class="mx-2 my-3"
            v-if="signatureIsAvilable == '1'"
            @click="signQuestionnaire()"
          >{{ $t('questionnaireForm.signSurvey') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from '@/services/axios'
import i18n from '@/plugins/i18n'

export default {
  name: 'questionnaireForm',
  data: () => ({
    dialog: false,
    hidenTabs: '',
    docId: '',
    docNum: '',
    docDate: '',
    currentPart: '',
    questionnaireName: '',
    questionnaireId: '',
    signatureIsAvilable: '',
    signature: '',
    questionnaireData: undefined,
    headers: [
      {
        colId: 'formColumnStartTime',
        text: 'Начало',
        value: 'startTime',
        align: 'center',
        class: 'table-col-small',
      },
      {
        colId: 'formColumnEndTime',
        text: 'Окончание',
        value: 'endTime',
        align: 'center',
        class: 'table-col-small',
      },
      {
        colId: 'formColumnWork',
        text: 'Работа',
        value: 'rowName',
        align: 'left',
      },
    ],
  }),
  computed: {
    globalTexts: function() {
      return i18n.messages[i18n.locale].global
    },
    questionnaireFormTexts: function() {
      return i18n.messages[i18n.locale].questionnaireForm
    },
  },
  created() {
    this.refreshListOptions()
  },
  methods: {
    refreshListOptions() {
      this.headers.forEach(element => {
        element.text = this.questionnaireFormTexts[element.colId]
      })
    },
    show(doc, questionnaireId) {
      this.docId = doc.id
      this.docNum = doc.docNum
      this.docDate = doc.docDate
      this.questionnaireId = questionnaireId

      this.fetchData()
      this.$nextTick(() => {
        this.dialog = true
      })
    },
    fetchData() {
      axios
        .request({
          url: '/QuestionnaireForm',
          params: {
            qFormID: this.questionnaireId,
            docId: this.docId,
          },
        })
        .then(resp => {
          this.questionnaireData = resp.data.questionnaireData
          this.questionnaireName = resp.data.questionnaireName
          this.signatureIsAvilable = resp.data.signatureIsAvilable
          this.signature = resp.data.signature
        })
    },
    signQuestionnaire() {
      axios
        .request({
          url: 'SignQuestionnaireForm',
          method: 'get',
          params: {
            qFormID: this.questionnaireId,
            docId: this.docId,
          },
        })
        .then(resp => {
          if (resp.data.status === '0') {
            this.dialog = false
          } else {
            const message = `${this.questionnaireFormTexts.formSaveError}: ${resp.data.statusDescription}`
            this.$emit('showSnack', { color: 'error', text: message })
          }
        })
        .catch(error => {
          const message = `${this.questionnaireFormTexts.formSaveError}: ${error.response.data.statusDescription}`
          this.$emit('showSnack', { color: 'error', text: message })
        })
      this.dialog = false
    },
    saveForm() {
      axios
        .request({
          url: 'SetQuestionnaireForm',
          method: 'post',
          data: {
            qFormID: this.questionnaireId,
            docId: this.docId,
            qFormData: this.questionnaireData,
          },
        })
        .then(resp => {
          if (resp.data.status === '0') {
            this.dialog = false
          } else {
            const message = `${this.questionnaireFormTexts.formSaveError}: ${resp.data.statusDescription}`
            this.$emit('showSnack', { color: 'error', text: message })
          }
        })
        .catch(error => {
          const message = `${this.questionnaireFormTexts.formSaveError}: ${error.response.data.statusDescription}`
          this.$emit('showSnack', { color: 'error', text: message })
        })
      this.dialog = false
    },
    checkEsc(ev) {
      if (ev.keyCode === 27) {
        this.dialog = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '../_scss/mixins';
@import '../_scss/breakpoints';

.accordion-row {
  margin-top: 15px;
  &:hover {
    text-decoration: none;
    background: rgb(102, 80, 80);
  }
  h5 {
    margin-top: 2px;
  }
}

.tab-row {
  .v-btn {
    @include xs {
      height: 20px;
    }
  }
}

.active-row {
  background: rgb(102, 80, 80);
}

.v-card__title {
  padding-bottom: 5px;
}

.v-card__text {
  padding-top: 5px;
}

.date-txt-holder {
  margin-left: 5px;
}

.auto-txt-holder {
  margin: 5px 5px;
}
</style>
